import moment from "moment";
import Validation from "./validation";

export default {
    range: function(from, to) {
        return (new Array(to - from + 1)).fill(1).map((v, i) => from + i);
    },
    normalizeToMoment: (input) => {
        const m = moment(input);
        console.log(m.utcOffset());
        return moment(m).utc();
    },
    formatTime: function(input, format)  {
        const m = moment(input);
        return moment(m).utc().add(m.utcOffset(), 'm').format(format);
    },
    exportComponent: function(cls) {
        if (window) {
            const cls_name = cls.name;
            console.log('add class:', `Colormel${cls_name}`);
            window[`Colormel${cls_name}`] = cls;
        }

        return cls;
    },
    url: function (...args) {
        return app.url(...args);
    },
    only: function(obj, ...args) {
        return Object.keys(obj).reduce((ret, key) => {
            if (args.indexOf(key) < 0) return ret;
            ret[key] = obj[key];
            return ret;
        }, {});
    },
    validation: (...selectors) => new Validation(selectors),
    loadImage: (src, done) => {
        const img = new Image;
        img.onload = img.onerror = () => {
            return done(img);
        };
        img.src = src;
    }
};
